function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "footer-instagram",
  fill: "#4A4A4A"
}, /*#__PURE__*/React.createElement("path", {
  id: "Body",
  d: "M14.7098911,1.30938734 C15.554678,2.16023437 16,3.32492676 16,4.67813017 L16,11.3218698 C16,12.7117565 15.5444876,13.8907146 14.6813579,14.7334098 C13.8335138,15.5618393 12.6595758,16 11.2859054,16 L4.71409464,16 C3.3669193,16 2.20215273,15.5608203 1.34717534,14.7303528 C0.465702821,13.8754299 0,12.6832251 0,11.2851866 L0,4.67813017 C0,1.88001528 1.88013502,0 4.67740908,0 L11.3225909,0 C12.688109,0 13.8600089,0.452426442 14.7098911,1.30938734 Z M13.5915759,2.42433504 C12.8833408,1.71024644 11.9067575,1.33324842 10.7688258,1.33324842 L5.23117424,1.33324842 C2.90011252,1.33324842 1.33333333,2.89982805 1.33333333,5.23144195 L1.33333333,10.7369717 C1.33333333,11.9019295 1.72141902,12.8953703 2.45597945,13.6077607 C3.16846061,14.2997728 4.13909942,14.6657326 5.26174554,14.6657326 L10.7382545,14.6657326 C11.8829799,14.6657326 12.8612615,14.3006219 13.5677982,13.610308 C14.287073,12.9081067 14.6666667,11.9257042 14.6666667,10.7675391 L14.6666667,5.23144195 C14.6666667,4.10384426 14.295565,3.13332908 13.5915759,2.42433504 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Lense",
  fillRule: "nonzero",
  d: "M8,10.65625 C9.46700637,10.65625 10.65625,9.46700637 10.65625,8 C10.65625,6.53299363 9.46700637,5.34375 8,5.34375 C6.53299363,5.34375 5.34375,6.53299363 5.34375,8 C5.34375,9.46700637 6.53299363,10.65625 8,10.65625 Z M8,12.25 C5.65278981,12.25 3.75,10.3472102 3.75,8 C3.75,5.65278981 5.65278981,3.75 8,3.75 C10.3472102,3.75 12.25,5.65278981 12.25,8 C12.25,10.3472102 10.3472102,12.25 8,12.25 Z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Viewfinder",
  cx: 12.075,
  cy: 3.775,
  r: 1
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7738229d.svg";
export { ForwardRef as ReactComponent };